export default {
  strict: false,
  namespaced: true,
  state: () => ({
    toggle: false,
    notificationType: "error",
    notificationMessage: ""
  }),
  mutations: {
    SET_TOGGLE(state, toggle) {
      state.toggle = toggle;
    },
    SET_NOTIFICATION_TYPE(state, notificationType) {
      state.notificationType = notificationType;
    },
    SET_NOTIFICATION_MESSAGE(state, notificationMessage) {
      state.notificationMessage = notificationMessage;
    }
  },
  actions: {
    SHOW_ERROR({ commit, state }, errorMessage) {
      commit("SET_NOTIFICATION_TYPE", "error");
      commit("SET_NOTIFICATION_MESSAGE", errorMessage);
      commit("SET_TOGGLE", true);
      setTimeout(() => {
        commit("SET_TOGGLE", false);
      }, 3000);
    },
    SHOW_SUCCESS({ commit, state }, successMessage) {
      commit("SET_NOTIFICATION_TYPE", "success");
      commit("SET_NOTIFICATION_MESSAGE", successMessage);
      commit("SET_TOGGLE", true);
      setTimeout(() => {
        commit("SET_TOGGLE", false);
      }, 3000);
    }
  }
};
